export default {
  atoms: {
    adSlot: {
      adLabel: 'Reklama'
    },
    accountToggleField: {
      leftLabel: {
        "default": '_TODO: No'
      },
      rightLabel: {
        "default": '_TODO: Yes'
      }
    },
    authSupportCopy: {
      copy: 'Dalej potrzebujesz pomocy? Chętnie pomożemy.',
      action: 'Napisz do nas na'
    },
    premiumIdentifier: {
      iconText: 'Premium'
    },
    recaptchaCopy: {
      agreeLineOne: 'Ta strona jest chroniona przez reCAPTCHA i',
      agreeLineTwo: 'Politykę Prywatności Google',
      agreeLineThree: 'i',
      agreeLineFour: 'regulamin',
      agreeLineFive: 'obowiązujący.',
      ariaLabel: {
        privacy: 'polityka prywatności',
        terms: 'regulamin'
      }
    },
    termsAndConditions: {
      agreeLineOne: 'Tworząc konto, wyrażasz zgodę na',
      agreeLineTwo: 'zasady',
      agreeLineThree: 'i',
      agreeLineFour: 'polityka prywatności',
      agreeLineFive: 'Immediate Media Company Limited. W każdym momencie możesz wypisać się z listy e-mailingowej.',
      ariaLabel: {
        privacy: 'polityka prywatności',
        terms: 'zasady i warunki'
      }
    },
    time: {
      conjunction: 'and',
      // v4 plural
      formatTimeHours_one: '{{hours}} godz.',
      formatTimeHours_few: '{{hours}} godz.',
      formatTimeHours_many: '{{hours}} godz.',
      formatTimeHours_other: '{{hours}} godz.',
      // v3 plural
      formatTimeHours: '{{hours}} godz.',
      formatTimeHours_plural: '{{hours}} godz.',
      formatTimeHours_0: '{{hours}} godz.',
      formatTimeHours_1: '{{hours}} godz.',
      formatTimeHours_2: '{{hours}} godz.',
      // v4 plural
      formatTimeMins_one: '{{minutes}} min',
      formatTimeMins_few: '{{minutes}} min',
      formatTimeMins_many: '{{minutes}} min',
      formatTimeMins_other: '{{minutes}} min',
      // v3 plural
      formatTimeMins: '{{minutes}} min',
      formatTimeMins_plural: '{{minutes}} min',
      formatTimeMins_0: '{{minutes}} min',
      formatTimeMins_1: '{{minutes}} min',
      formatTimeMins_2: '{{minutes}} min'
    },
    instagramEmbed: {
      viewPostOnInstagram: 'Wyświetl ten post na Instagramie'
    }
  },
  hoc: {
    withAccessibleMenu: {
      backButtonText: 'Menu główne'
    }
  },
  molecules: {
    accountNav: {
      defaultLabel: 'Moje konto',
      registerText: 'Zarejestruj się',
      signInText: 'Zaloguj się',
      ariaLabel: {
        account: 'Konto'
      }
    },
    adBanner: {
      ariaLabel: {
        dismissText: 'Pomiń reklamę'
      }
    },
    ageVerificationModal: {
      title: 'Weryfikacja wieku',
      intro: 'UWAGA! Ta strona zawiera treści przeznaczone wyłącznie dla osób dorosłych',
      deny: 'Nie mam {{ageLimit}} lat',
      confirm: 'Mam {{ageLimit}} lat',
      moreInfo: 'Więcej informacji',
      remember: 'Zapamiętaj mnie.'
    },
    authDropDown: {
      registerText: 'Zarejestruj się',
      signInText: 'Zaloguj się'
    },
    batchedGrid: {
      showingItemsText: 'Pokazuje przedmioty od 1 do {{nItemsShown}} z {{nItems}}',
      viewMoreButtonText: 'Zobacz więcej',
      showMoreButtonsText: 'Pokaż więcej'
    },
    cookAndPrepTime: {
      sr: {
        timeRange: 'Czas przygotowania i gotowania'
      },
      timeRange: {
        cook: 'Gotować:',
        prep: 'Przygotowywać:',
        total: 'Czas całkowity'
      }
    },
    eyebrowNav: {
      ariaLabel: {
        quickLinks: 'Szybkie linki'
      }
    },
    formAutoComplete: {
      ariaLabel: {
        noResult: 'Brak wyniku',
        search: 'Szukaj'
      }
    },
    formImageUpload: {
      button: {
        loadPrompt: 'Kliknij, aby dodać zdjęcie',
        loadPromptRequired: 'wymagane',
        loadPromptOptional: 'opcjonalne',
        ownImage: '*Proszę upewnij się, że to twój obrazek',
        remove: 'Usuń',
        rotateLeft: 'Obróć w prawo',
        rotateRight: 'Obróć w lewo',
        save: 'Zapisz'
      },
      error: {
        maxFileSize: 'Rozmiar pliku jest za duży, dodaj obrazek mniejszy niż {(maxFileSize}}MB',
        minHeight: 'Obrazek nie spełnia wymaganej minimalnej wysokości {{minDimensions}}px',
        minWidth: 'Obrazek nie spełnia wymaganej minimalnej szerokości {{minDimensions}}px'
      }
    },
    formMultiSelect: {
      ariaLabel: {
        formInput: 'Filtr {{label}}'
      },
      filterOptions: {
        noResult: 'Brak wyników',
        selectAllLabel: 'Wybierz wszystko',
        inputPlaceholderSelect: 'Wybierz...',
        inputPlaceholderSelected: 'wybrany'
      },
      sr: {
        optionsButton: 'Przełącz wyświetlanie opcji'
      }
    },
    formSortableInputs: {
      ariaLabel: {
        deleteInput: 'Usuń',
        grab: 'Chwyć i przesuń'
      }
    },
    formSubmitButton: {
      button: {
        savedText: 'Zapisane',
        savingText: 'Zapisywanie'
      }
    },
    gallery: {
      ariaLabel: {
        fullScreen: 'otwórz galerię w trybie pełnoekranowym'
      },
      imgCountText: '{{slideCount}} z {{images}}'
    },
    glossaryNav: {
      ariaLabel: {
        nav: 'słowniczek'
      }
    },
    heightClamper: {
      button: {
        expandTextMore: 'Pokaż więcej',
        expandTextLess: 'Pokaż mniej'
      }
    },
    ingredientsList: {
      heading: 'Składniki'
    },
    inlineGallery: {
      imageCount: '{{imageCount}} z {{totalImages}}'
    },
    keyValueBlocks: {
      keyHeader: 'Klucz',
      prefixHeader: 'Podświetlenie',
      valueHeader: 'Wartość'
    },
    lightBox: {
      ariaLabel: {
        close: 'zamknij'
      }
    },
    loadingIcon: {
      sr: {
        icon: 'Ładowanie'
      }
    },
    loadingState: {
      "default": {
        heading: 'Jeszcze chwila...'
      },
      createAccount: {
        heading: 'Trzymaj się mocno!',
        subHeading: 'Konfigurujemy Twoje konto'
      },
      logout: {
        heading: 'Jeszcze chwila...',
        subHeading: 'Wylogowujesz się.'
      }
    },
    methodList: {
      methodLabel: 'Sposób przygotowania',
      counterPrefix: 'Krok'
    },
    modal: {
      ariaLabel: {
        close: 'Zamknij modal'
      }
    },
    numericPaginator: {
      icon: {
        prev: 'Wstecz',
        next: 'Następny'
      },
      sr: {
        icon: 'Strona',
        nav: 'Jesteś aktualnie na {{page}} stronie'
      }
    },
    passwordCriteria: {
      ariaLabel: {
        notSatisfied: 'Nie spełnia wymagań',
        satisfied: 'Spełnia wymagania'
      },
      config: {
        bothCase: 'Małe i duże litery',
        lowerCase: 'Małe litery',
        // v4 plural
        minLength_one: 'Przynajmniej {{minLength}} znak',
        minLength_few: 'Przynajmniej {{minLength}} znaki',
        minLength_many: 'Przynajmniej {{minLength}} znaków',
        minLength_other: 'Przynajmniej {{minLength}} znaków',
        // v3 plural
        minLength: 'Przynajmniej {{minLength}} znak',
        minLength_plural: 'Przynajmniej {{minLength}} znaków',
        minLength_0: 'Przynajmniej {{minLength}} znak',
        minLength_1: 'Przynajmniej {{minLength}} znaki',
        minLength_2: 'Przynajmniej {{minLength}} znaków',
        requireDigit: 'Liczba (np. 0–9)',
        symbol: 'Symbol (np. !, ?, @)',
        upperCase: 'Duże litery'
      },
      passwordContain: {
        text: 'YTwoje hasło musi zawierać'
      },
      sr: {
        passwordContain: 'Twoje hasło musi zawierać:'
      }
    },
    passwordInput: {
      buttonText: {
        hide: 'UKRYJ',
        show: 'POKAŻ'
      },
      formLabels: {
        currentPassword: '_TODO: Current password',
        newPassword: '_TODO: New password',
        password: 'Hasło'
      },
      placeholder: 'Wprowadź hasło',
      sr: {
        strength: 'Siła hasła to {{passwordStrength}}',
        visibility: {
          hidden: 'Ukryj hasło',
          shown: 'Pokaż hasło'
        }
      }
    },
    plantOverview: {
      averageYield: 'Średni plon::',
      depth: 'Głebokość:',
      size: 'Rozmiar rośliny:',
      spacing: 'Odstępy:',
      spacingApart: '{{spacingApart}} od siebie',
      spacingBetween: '{{spacingBetweenRows}} odstępy pomiędzy rzędami'
    },
    popupToggleButton: {
      ariaLabel: {
        toggle: 'Przełącz popup {{popup}}'
      }
    },
    postContentStream: {
      ariaMessage: {
        itemsAdded: 'Nowe elementy dodane do',
        singleItemAdded: 'Nowy element dodany do'
      }
    },
    postTeaser: {
      readMore: 'Czytaj więcej',
      publishDate: 'Opublikowano: {{published}}'
    },
    rate: {
      sr: {
        legend: 'Ile dasz gwiazdek z {{bestRating}}?',
        outOf: 'z',
        // v4 plural
        star_one: 'gwiazdka',
        star_few: 'gwiazdki',
        star_many: 'gwiazdek',
        star_other: 'gwiazdek',
        // v3 plural
        star: 'gwiazdka',
        star_plural: 'gwiazdek',
        star_0: 'gwiazdka',
        star_1: 'gwiazdki',
        star_2: 'gwiazdek'
      }
    },
    rating: {
      ariaLabel: {
        rating: 'ocena'
      },
      countText: '{{count}} {{label}}',
      types: {
        // v4 plural
        rating_one: 'ocena',
        rating_few: 'oceny',
        rating_many: 'ocen',
        rating_other: 'ocen',
        // v3 plural
        rating: 'ocena',
        rating_plural: 'oceny',
        rating_0: 'ocena',
        rating_1: 'oceny',
        rating_2: 'ocen',
        // v4 plural
        review_one: 'recenzja',
        review_few: 'recenzje',
        review_many: 'recenzji',
        review_other: 'recenzji',
        // v3 plural
        review: 'recenzja',
        review_plural: 'recenzji',
        review_0: 'recenzja',
        review_1: 'recenzje',
        review_2: 'recenzji'
      },
      inlineRateText: 'Ocena',
      skeletonRateText: 'Ocena'
    },
    ratingsCriteria: {
      overallLabel: 'Ocena ogólna'
    },
    searchForm: {
      ariaLabel: {
        performSearch: 'Wyszukaj',
        resetButton: 'Resetuj dane'
      }
    },
    sideBarNav: {
      ariaLabel: {
        settings: 'Moje ustawienia',
        verticalNav: 'Strona'
      }
    },
    socialShare: {
      sr: {
        iconEmail: 'E-mail do przyjaciela',
        iconShare: 'Udostępnij na {{platform}}'
      }
    },
    socialSignInButton: {
      signUpWithButtonText: 'Zarejestruj się',
      continueWithButtonText: 'Kontynuuj'
    },
    tableClamper: {
      collapseButtonText: 'Pokaż mniej',
      expandButtonText: 'Pokaż więcej'
    },
    truncatedIcons: {
      tooltipLabel: 'więcej'
    },
    accountDetails: {
      copy: {
        lineOne: '_TODO: We need your first name and last name so we can personalise correspondence.',
        lineTwo: '_TODO: Your screen name is public and may be seen by other members if you post on our site.'
      },
      firstNameLabel: '_TODO: First name',
      lastNameLabel: '_TODO: Last name',
      screenNameLabel: '_TODO: Screen name (public)',
      screenNamePlaceholder: '_TODO: Screen name',
      emailLabel: '_TODO: Email address',
      formLegend: '_TODO: Account details form',
      inputErrorMessages: {
        firstName: {
          tooLong: '_TODO: First name must be no longer than 100 characters'
        },
        lastName: {
          tooLong: '_TODO: Last name must be no longer than 100 characters'
        },
        email: {
          tooLong: '_TODO: Email address must be no longer than 100 characters',
          typeMismatch: '_TODO: Please enter a valid email address',
          valueMissing: '_TODO: Please enter an email address'
        },
        screenName: {
          tooLong: '_TODO: Screen name must be no longer than 100 characters',
          valueMissing: '_TODO: Please enter a screen name'
        }
      },
      saveButtonText: {
        "default": '_TODO: Save changes',
        saving: '_TODO: Saving',
        saved: '_TODO: Saved'
      }
    },
    accountManagement: {
      changePassword: {
        readOnly: {
          copy: '_TODO: This information is hidden',
          label: '_TODO: Password'
        },
        edit: {
          cancelButtonText: '_TODO: Cancel',
          currentPasswordLabel: '_TODO: Current password',
          label: '_TODO: Change password',
          newPasswordLabel: '_TODO: New password',
          submitButtonText: '_TODO: Save changes'
        }
      },
      deleteAccount: {
        label: '_TODO: Delete account',
        copy: '_TODO: To request permanent deletion of your account please click',
        copyLink: '_TODO: here'
      },
      formLegend: '_TODO: Account management form'
    }
  },
  organisms: {
    emailSentConfirmation: {
      accountVerificationHeading: 'Wysłaliśmy e-mail weryfikacyjny na adres ',
      passwordResetHeading: 'Jeśli masz konto, otrzymasz email, aby zresetować swoje hasło. ',
      resendEmailCopy: 'Nie otrzymałeś wiadomości e-mail? ',
      bodyCopy: 'Pamiętaj, aby sprawdzić wszystkie foldery w skrzynce odbiorczej, w tym spam.',
      resendEmailButton: 'Kliknij, aby wysłać ponownie',
      supportEmailSubject: 'Potrzebuję pomocy, żeby zweryfikować swoje konto.'
    },
    cardBuilder: {
      ariaLabel: {
        mediaImage: 'Zobacz {{title}}'
      },
      offerCodeText: 'użyj kodu: {{offerCode}}'
    },
    cardCarouselSection: {
      errorMessage: 'Coś poszło nie tak podczas ładowania danych. Spróbuj innej opcji.',
      formLabel: 'Opcje',
      infoMessage: 'Przepraszamy, brak danych.',
      slidesToShowItems: 'Pokazywanie elementów od {{currentSlide}} do {{nextSlides}} z {{allSlides}}',
      slidesToShowItem: 'Pokazywanie elementu {{currentSlide}} z {{allSlides}}'
    },
    carousel: {
      sr: {
        iconStack: '{{direction}} element',
        paging: 'Strona {{pageNumber}}'
      }
    },
    changeEmailConfirmation: {
      bodyCopy: '_TODO: For your security, please enter your password to continue',
      submitButton: '_TODO: Go to my account'
    },
    resetPasswordForm: {
      bodyCopy: '_TODO: Enter a password for',
      submitButton: 'Potwierdź hasło'
    },
    collection: {
      ariaLabel: {
        edit: 'Edytuj',
        registerButton: 'Zarejestruj się',
        share: 'Udostępnij',
        signinButton: 'Zaloguj się'
      },
      author: '{{author}}',
      signinLinkText: 'Zaloguj się',
      signInLinkTitle: 'Zaloguj się',
      signInPromptLineOne: 'Czy to twoja kolekcja?',
      signInPromptLineTwo: 'aby edytować'
    },
    dynamicAccordian: {
      // v4 plural
      nextLabel_one: 'Pokaż następne {{count}} element',
      nextLabel_few: 'Pokaż następne {{count}} elementy',
      nextLabel_many: 'Pokaż następne {{count}} elementów',
      nextLabel_other: 'Pokaż następne {{count}} elementy',
      // v3 plural
      nextLabel: 'Pokaż następne {{count}} element',
      nextLabel_plural: 'Pokaż następne {{count}} elementy',
      nextLabel_0: 'Pokaż następne {{count}} element',
      nextLabel_1: 'Pokaż następne {{count}} elementy',
      nextLabel_2: 'Pokaż następne {{count}} elementów',
      // v4 plural
      previousLabel_one: 'Pokaż poprzednie {{count}} element',
      previousLabel_few: 'Pokaż poprzednie {{count}} elementy',
      previousLabel_many: 'Pokaż poprzednie {{count}} elementów',
      previousLabel_other: 'Pokaż poprzednie {{count}} elementów',
      // v3 plural
      previousLabel: 'Pokaż poprzednie {{count}} element',
      previousLabel_plural: 'Pokaż poprzednie {{count}} elementów',
      previousLabel_0: 'Pokaż poprzednie {{count}} element',
      previousLabel_1: 'Pokaż poprzednie {{count}} elementy',
      previousLabel_2: 'Pokaż poprzednie {{count}} elementów'
    },
    embeddedPost: {
      ariaLabel: {
        viewArticle: 'Zobacz {{title}}'
      }
    },
    filters: {
      ariaLabel: {
        activeFilters: 'Aktywne filtry',
        closeFilters: 'Zamknij pasek boczny filtrów',
        refine: 'Wyszukiwanie',
        showMoreFilters: 'Pokaż więcej filtrów',
        clearFiltersText: 'Wyczyść wszystkie filtry'
      },
      button: {
        clearFiltersText: 'Wyczyść',
        refineText: 'Wyszukiwanie',
        showMoreFiltersText: 'Więcej filtrów',
        closeText: 'Zamknij'
      },
      clearAll: 'Wyczyść wszystko',
      refineText: 'Zawęź swoje wyniki',
      yourFilters: 'Twoje filtry:',
      sr: {
        closeFilters: 'Zamknij pasek boczny filtrów'
      }
    },
    listPage: {
      showMoreButtonsText: 'Załaduj więcej'
    },
    liveBlog: {
      errorMessage: 'Przepraszamy, coś poszło nie tak podczas ładowanie elementów, spróbuj ponownie.',
      isLiveUpdatedText: 'NA ŻYWO uaktualnione {{duration}}',
      liveIconTitle: 'na żywo',
      liveKickerTitle: 'Na żywo',
      loadMoreButtonText: 'Załaduj więcej',
      notLiveUpdatedText: 'Uaktualnione {{duration}}',
      statusText: 'Relacja na żywo z tego wydarzenia dobiegła końca',
      time: {
        // v4 plural
        lessThanOneHour_one: '{{count}} minuty temu',
        lessThanOneHour_few: '{{count}} minuty temu',
        lessThanOneHour_many: '{{count}} minuta temu',
        lessThanOneHour_other: '{{count}} minuta temu',
        // v3 plural
        lessThanOneHour: '{{count}} minuty temu',
        lessThanOneHour_plural: '{{count}} minut temu',
        lessThanOneHour_0: '{{count}} minuta temu',
        lessThanOneHour_1: '{{count}} minuty temu',
        lessThanOneHour_2: '{{count}} minut temu',
        lessThanOneMinute: 'mniej niż minutę temu',
        // v4 plural
        moreThanHour_one: '{{count}} godzina temu',
        moreThanHour_few: '{{count}} godziny temu',
        moreThanHour_many: '{{count}} godziny temu',
        moreThanHour_other: '{{count}} godziny temu',
        // v3 plural
        moreThanHour: '{{count}} godzina temu',
        moreThanHour_plural: '{{count}} godziny temu',
        moreThanHour_0: '{{count}} godzina temu',
        moreThanHour_1: '{{count}} godziny temu',
        moreThanHour_2: '{{count}} godzin temu'
      }
    },
    loginLanding: {
      button: {
        loginText: 'Zaloguj się za pomocą maila'
      },
      link: {
        createAccountText: 'Załóż konto'
      },
      dividerText: 'LUB',
      newHereText: 'Nowy użytkownik?',
      loginHeaderText: 'Witaj ponownie. Tęskniliśmy za Tobą, cieszymy się, że jesteś.'
    },
    loginForm: {
      emailLabel: 'Email',
      emailPlaceholder: 'Wpisz swój email',
      loginFormHeaderText: 'Wprowadź swoje dane, aby  zalogować się na swoje konto',
      button: {
        loginText: 'Zaloguj się'
      },
      link: {
        forgotPasswordText: 'Nie pamiętasz hasła?'
      }
    },
    mainNav: {
      ariaLabel: {
        main: 'Treść główna'
      },
      sr: {
        tierThreeBack: 'Wróć do',
        tierTwoBack: 'Wróć do'
      }
    },
    marketingPreferencesForm: {
      button: {
        saveMyPreferencesText: 'Zapisz moje preferencje'
      },
      checkbox: {
        label: 'Tak, zapisz mnie'
      },
      heading: 'Czy chcesz otrzymywać oferty od firmy {{brand}} i jej wydawcy Immediate Media Company Limited?',
      notification: {
        error: 'Nie udało się zapisać Twoich preferencji. Odwiedź Moje konto i zaktualizuj swoje ustawienia.'
      }
    },
    newsLetterSignUp: {
      input: {
        emailPlaceholder: 'Adres e-mail'
      }
    },
    post: {
      ariaLabel: {
        calloutButtonEdit: 'Edytuj',
        calloutButtonPublish: 'Opublikuj'
      },
      productSpec: {
        collapseButtonText: 'Mniej szczegółów',
        expandButtonText: 'Więcej szczegółów',
        headline: 'Specyfikacja produktu',
        skip: 'Idź do specyfikacji produktu'
      },
      sr: {
        sponsoredHeading: 'Kontent sponsorowany'
      }
    },
    postHeader: {
      button: {
        dealsText: 'Pomiń, aby zobaczyć oferty',
        print: 'Drukuj'
      },
      itemCount: {
        // v4 plural
        items_one: 'element',
        items_few: 'elementy',
        items_many: 'elementów',
        items_other: 'elementów',
        // v3 plural
        items: 'element',
        items_plural: 'elementów',
        items_0: 'element',
        items_1: 'elementy',
        items_2: 'elementów'
      },
      ourRatingText: 'Nasza ocena',
      publishDate: 'Opublikowano: {{published}}'
    },
    reaction: {
      ariaLabel: {
        "delete": 'Usuń'
      },
      button: {
        replyText: 'Odpowiedz',
        reportText: 'Zgłoś'
      },
      removedText: 'To zostało usunięte'
    },
    registrationForm: {
      createText: 'Utwórz konto',
      emailPlaceholder: 'Wpisz swój email',
      srButton: 'przycisk.',
      emailLabel: 'Email'
    },
    registrationLanding: {
      ariaLabel: {
        signUpText: 'Kliknij i zarejestruj się swoim e-mailem'
      },
      button: {
        signUpText: 'Zarejestruj się swoim e-mailem'
      },
      link: {
        loginText: 'Zaloguj sie'
      },
      dividerText: 'LUB',
      alreadyRegisteredText: 'Już zarejestrowany?',
      registrationHeaderText: 'Utwórz konto {{brand}} i otrzymuj nasze ekskluzywne biuletyny e-mailowe.'
    },
    forgottenPasswordForm: {
      formCopy: 'Wpisz email, którym się zarejestrowałeś, my pomożemy ci zresetować hasło.',
      emailLabel: 'Email',
      emailPlaceholder: 'Wpisz swój email',
      resetPasswordButtonText: 'Zresetuj hasło'
    },
    reviewSummary: {
      heading: 'Co przetestowaliśmy'
    },
    roastCalculator: {
      button: {
        resetText: 'Zresetuj'
      },
      imperialLabel: 'Imperialny',
      metricLabel: 'Metryczny',
      sr: {
        imperialValueOunces: 'Miara w uncjach',
        imperialValuePounds: 'Miara w funtach',
        metricConverterLabel: 'Wartość metryczna w {{converter}} unit',
        metricConverterUnit: '{{converter}} jednostka',
        selectMeat: 'Wybierz mięso'
      },
      meat: {
        beefMedium: 'Wołowina (średnio wysmażona)',
        beefRare: 'Wołowina (krwista)',
        beefWellDone: 'Wołowina (dobrze wysmażona)',
        chicken: 'Kurczak',
        duck: 'Kaczka',
        goose: 'Gęś',
        lambMedium: 'Jagnięcina (średnio wysmażona)',
        lambRare: 'Jagnięcina (krwista)',
        lambWellDone: 'Jagnięcina (dobrze wysmażona)',
        pork: 'Wieprzowina',
        turkey: 'Indyk',
        venisonMedium: 'Sarnina (średnio wysmażona)',
        venisonRare: 'Sarnina (krwista)',
        venisonWellDone: 'Sarnina (dobrze wysmażona)'
      }
    },
    searchResults: {
      button: {
        loadPrevious: 'Załaduj poprzednie',
        loadNext: 'Załaduj następne'
      },
      showingItems: 'Wyświetlanie {{from}} do {{to}} z {{total}} elementów',
      noResults: 'Przepraszamy, coś poszło źle podczas ładowania wyników wyszukiwania, spóbuj jeszcze raz.'
    },
    siteFooter: {
      privacyItemLabel: 'Moje zgody',
      privacyItemTitle: 'Moje zgody'
    },
    verificationError: {
      errorWithRetrySignUpCopy: 'Podczas weryfikacji twojego konta natknęliśmy się na problem. Spróbuj zarejestrować się jeszcze raz lub skontaktuj się z działem wsparcia.',
      errorWithResendEmailCopy: 'Przepraszamy! Kliknij poniżej, żeby otrzymać email weryfikacyjny jeszcze raz.',
      linkExpiredWithResendEmailCopy: 'Link, który wysłaliśmy jest już nieaktywny. Robimy to, żeby zachować bezpieczeństwo twojego konta. Kliknij poniżej, żeby otrzymać nowy email weryfikacyjny.',
      supportEmailSubject: 'Potrzebuję pomocy, żeby zweryfikować swoje konto.'
    },
    weightVolumeConverter: {
      ariaLabel: {
        imperialValue: 'Wartość imperialna w {{units}}',
        imperialValueOther: 'Wartość imperialna w {{units}}',
        metricUnitText: 'Wybór jednostki metrycznej',
        metricValueText: 'Wartość metryczna'
      },
      sr: {
        imperialValue: 'Wartość imperialna w {{units}}',
        imperialValueOther: 'Wartość imperialna w {{units}}',
        metricUnitText: 'Jednostka metryczna',
        metricValueText: 'Wartość metryczna'
      },
      volumeText: 'Objętość',
      weightText: 'Waga'
    }
  },
  templates: {
    searchPage: {
      title: 'Twoje wyniki wyszukiwania',
      noResults: 'Przepraszamy, nie udało nam się znaleźć żadnych wyników. Proszę spróbuj zaktualizować swoje zapytanie.',
      error: 'Przepraszamy, wystąpił problem z wczytaniem wyników wyszukiwania.',
      sort: 'sortowanie'
    }
  }
};